import React, { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect';
import SideNavClass from './SideNavClass';
import { MDBAlert, MDBBadge, MDBBtn, MDBCard, MDBCardBody, MDBCardText, MDBCardTitle, MDBCheckbox, MDBChip, MDBCol, MDBDatatable, MDBDatepicker, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBRow, MDBSelect, MDBTextArea, MDBTimepicker } from 'mdb-react-ui-kit';
import CreateCancellationPolicy from '../../components/class/CreateCancellationPolicy';
import { deleteCancellationPolicy, getCancellationPolicy, logEvent } from '../../services/classApiServices.js';
import { browserName, browserVersion } from "react-device-detect";
import { useAnalytics } from '../../hooks/useAnalytics';
import { useAccess } from '../../context/AccessContext';
import ro from 'date-fns/esm/locale/ro/index.js';



const CancelationPolicy = () => {
    const { trackButtonClick } = useAnalytics();
    const [modeOpen, setModeOpen] = useState(true);
    const [mode, setMode] = useState('side');
    const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
    const isAdmin = loggedUserInfo?.role !== "staff";
    const { loading, handlePageAccess, handleClassPageAssess } = useAccess();
    const roleAccess = handleClassPageAssess("cancelationpolicy")
    useEffect(() => {
        if (isMobile) {
            setModeOpen(false)
            setMode("over")
        }
    }, [])

    const sideNav = () => {
        setModeOpen(!modeOpen);
        if (isMobile) {
            setMode("over")

        } else {
            setMode("side")
        }
    }

    const truncateContent = (content, maxLength) => {
        if (content && (content.length > maxLength)) {
            return content.substring(0, maxLength) + '...';
        } else {
            return content;
        }
    };
    const stripHtmlTags = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    };



    const [centredModal, setCentredModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const toggleOpen = () => setCentredModal(!centredModal);
    const toggleDeleteModal = () => setDeleteModal(!deleteModal);
    const [refresh, setRefresh] = useState(false)
    const [policyid, setPolicyid] = useState(-1)
    const [policyData, setPolicyData] = useState([])
    const [policyInfo, setPolicyInfo] = useState(null)
    const columns = [
        { label: 'S.no', field: 'sno', sort: 'asc' },
        { label: 'Policy Name', field: 'policyName' },
        { label: 'Description', field: 'description' },
        { label: 'Policy', field: 'policy' },
    ]
    if (roleAccess?.editpolicy !== 2) {
        columns.push({ label: 'Actions', field: 'actions', sort: false },)
    }
    const [basicData, setBasicData] = useState({
        columns: columns,
        rows: [],
    });
    const [PolicyName, setPolicyName] = useState()
    console.log("PolicyName", PolicyName)
    const [Error2, setError2] = useState("")

    useEffect(() => {

        const fetchData = async () => {
            const response = await getCancellationPolicy(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            if (!response || response === "false") {
                return;
            }
            const policyinfo = await response.json();

            console.log(policyinfo, 'Policyinfo');
            setPolicyData(policyinfo)
            setRefresh(false)
        }
        if (localStorage.getItem("loggedUserInfo")) {
            fetchData()
        }


    }, [refresh])


    const handleEdit = (data) => {
        setPolicyInfo(data)
        toggleOpen()
    }

    const confirmDelete = async () => {
        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};
        const fullName = userInfo?.name || `${userInfo?.fname || ""} ${userInfo?.lname || ""}`.trim() || "User";
        const username1 = userInfo.email || "Guest";
        const gymid = userInfo.gymid || "";
        const ip = localStorage.getItem("ipaddress");
        const browserinfo = `${browserName}-${browserVersion}.0.0`;

        const flag = `Cancellation policy deleted sucessfully(${PolicyName?.name})`;


        try {
            const res = await deleteCancellationPolicy(gymid, policyid);

            console.log("Delete API response:", res);
            console.log("Setting Error2 to:", flag);

            setError2(flag);


            setRefresh(true);
            setDeleteModal(false);

            await logEvent(
                {
                    Eventtype: username1,
                    username1,
                    fullName,
                    ip,
                    flag,
                    browserinfo,
                    gymid,
                    isclass: true
                },
                gymid
            );
            await trackButtonClick("CancelationPolicy", "Delete_Policy", "staff", {});

        } catch (err) {
            console.error("Failed to delete cancellation policy:", err);
        }
    };

    const handleDelete = (data) => {
        setPolicyName(data)
        setPolicyid(data._id)
        setDeleteModal(true)
    }

    useEffect(() => {
        const popupRow = [];

        if (policyData && policyData.length > 0) {

            policyData.forEach((item, index) => {

                const rowData = {
                    sno: index + 1,
                    policyName: item.name,
                    // description: item.description ? item.description : "--",
                    description: <div className="ps-0" title={stripHtmlTags(item.description ? item.description : "--")} dangerouslySetInnerHTML={{ __html: truncateContent(item.description ? item.description : "--", 300) }} />,
                    policy: item?.cancelfee && item?.cancelfee.length > 0
                        ? (
                            <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                {item.cancelfee.map((fee, feeIndex) => (
                                    <li key={feeIndex} style={{ marginBottom: '8px' }}>
                                        {fee.days} day{fee.days > 1 ? "s" : ""} before - {fee.feevalue}% Fee
                                    </li>
                                ))}
                            </ul>
                        )
                        : "",
                    ...(roleAccess?.editpolicy !== 2 ? {
                        actions: (
                            <>
                                <div style={{ display: "flex" }}>
                                    <div onClick={() => handleEdit(item)}>
                                        <MDBIcon icon="edit" className='me-3 fs-6' />
                                    </div>
                                    <div onClick={() => handleDelete(item)}>
                                        <MDBIcon icon="trash" className='fs-6' />
                                    </div>
                                </div>
                            </>
                        ),
                    } : {}),

                };
                popupRow.push(rowData);

            });

        }

        // console.log(popupRow);

        setBasicData(prevData => ({
            ...prevData,
            rows: popupRow
        }));

    }, [policyData]);




    const handleSave = (flag) => {
        setRefresh(true);
        setPolicyInfo(null)
        setCentredModal(false);

        if (flag) {
            setError2(flag);
        }
    }

    const handlecancel = () => {
        setPolicyInfo(null)
        toggleOpen()
    }


    return (
        <>
            <SideNavClass activeTab={"CancelationPolicy"} modeOpen={modeOpen} setModeOpen={setModeOpen} mode={mode} setMode={setMode} >

                {isMobile && <>
                    <header class="gym-container gym-hide-large gym-red  gym-padding d-flex align-items-center p-3">
                        <div onClick={() => sideNav()} className='cursor-pointer'>
                            <MDBIcon fas icon='bars' size='lg' />
                        </div>
                        <h5 class="ms-3 mb-0 d-inline">EasyMembr</h5>
                    </header>
                </>}

                <MDBCard className='shadow-3 overflow-hidden'>
                    <MDBCardBody className='custom-card-height'>
                        <div className="d-flex align-items-center justify-content-between">
                            <h5 className='m-0'>
                                Cancelation Policy
                            </h5>
                            {roleAccess?.editpolicy !== 2 &&
                                <>
                                    <MDBBtn color='success' className='text-capitalize' onClick={toggleOpen}>
                                        <MDBIcon fas icon="plus" className="me-2" />Create Policy</MDBBtn></>}
                        </div>
                        <div className="mt-3 CancelationPolicydatatable">
                            <MDBDatatable hover
                                search
                                data={basicData}
                            />
                        </div>
                    </MDBCardBody>
                </MDBCard>




            </SideNavClass>

            <MDBAlert
                color='success'
                autohide
                position='top-center'
                delay={5000}
                appendToBody
                open={Error2 !== ""}
                onClose={() => setError2("")}
                style={{ zIndex: 9999 }}
            >
                {Error2}
            </MDBAlert>


            {centredModal && <MDBModal tabIndex='-1' open={centredModal} onClose={() => setCentredModal(false)}>
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <CreateCancellationPolicy
                            ispopup="0"
                            onSave={handleSave}
                            onclose={handlecancel}
                            policyinfo={policyInfo}
                        />
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>}





            {/* Delete Confirmation Modal */}
            <MDBModal tabIndex="-1" open={deleteModal} onClose={() => setDeleteModal(false)}>
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Confirm Deletion</MDBModalTitle>
                            <MDBBtn className="btn-close" color="none" onClick={() => setDeleteModal(false)}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <p>Are you sure you want to delete this class?</p>
                        </MDBModalBody>
                        <MDBModalFooter className='pe-2 pb-2'>
                            <MDBBtn color="secondary" onClick={() => setDeleteModal(false)}>
                                Cancel
                            </MDBBtn>
                            <MDBBtn color="danger" onClick={confirmDelete}>
                                Delete
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>



        </>
    )
}

export default CancelationPolicy
